





























































































import {
  BSidebar,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BSpinner,
  BFormFile
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { PlanningPrevisionnelCreateModel } from "@/api/models/planningsPrevisionnels/planningPrevisionnel";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BSidebar,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormFile
  },
  name: "create-planning-previsionnel",
})
export default class CreatePlanningPrevisionnel extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewPlanningPrevisionnelSidebarActive!: boolean;
  loading = false;

  required = required;

  newPlanningPrevisionnel: PlanningPrevisionnelCreateModel = {};

  resetForm() {
    this.newPlanningPrevisionnel = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .createPlanningPrevisionnelEntreprise(this.$route.params.id, this.newPlanningPrevisionnel)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un planning prévisionnel",
            text: "Planning prévisionnel créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-plannings-previsionnels");
        this.$emit("update:is-add-new-planning-previsionnel-sidebar-active", false);
        this.loading = false;
      });
  }
}
